var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconGenericFile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 1.333C2 .597 2.599 0 3.327 0h12.006L22 6.667v16.002c0 .735-.599 1.331-1.328 1.331H3.328A1.328 1.328 0 012 22.667V1.333z",
    fill: "#ECEDEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 22h20v.67A1.33 1.33 0 0120.67 24H3.33A1.33 1.33 0 012 22.67V22z",
    fill: "#00347A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.333 0v5.334a1.33 1.33 0 001.333 1.333H22L15.333 0z",
    fill: "#C8CDD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.344 10.9a.4.4 0 110-.8h10.335a.4.4 0 110 .8H5.344zM5.344 12.9a.4.4 0 110-.8h10.335a.4.4 0 110 .8H5.344zM5.344 14.9a.4.4 0 110-.8h10.335a.4.4 0 110 .8H5.344zM5.318 16.9a.4.4 0 110-.8h6.364a.4.4 0 110 .8H5.318z",
    fill: "#00347A"
  }))));
}

export default SvgIconGenericFile;